<template>
  <div class="animated fadeIn">
    <logs-usuarios-list />
  </div>
</template>

<script>
import LogsUsuariosList from './components/list/LogsUsuariosList.vue'

export default {
  name: 'LogsUsuarios',
  components: {
    LogsUsuariosList
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/auditoria/logs-usuarios/LogsUsuarios.vue